export const TYPE_COLORS = {
  error: {
    iconColor: "bg-red-50 border-red-200 text-red-600",
    buttonColor: "bg-red-600 hover:bg-red-700",
    icon: (
      <svg
        className="w-9 h-9"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    ),
  },
  info: {
    iconColor: "bg-blue-50 border-blue-200 text-blue-600",
    buttonColor: "bg-blue-600 hover:bg-blue-700",
    icon: (
      <svg
        className="w-9 h-9"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
  },
  warning: {
    iconColor: "bg-orange-50 border-orange-200 text-orange-600",
    buttonColor: "bg-orange-600 hover:bg-orange-700",
    icon: (
      <svg
        className="w-9 h-9"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    ),
  },
};
